var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.6777 5.94926C22.0682 6.33978 22.0682 6.97295 21.6777 7.36347L9.65685 19.3843L3.29289 13.0203C2.90237 12.6298 2.90237 11.9966 3.29289 11.6061C3.68342 11.2156 4.31658 11.2156 4.70711 11.6061L9.65685 16.5559L20.2635 5.94926C20.654 5.55873 21.2871 5.55873 21.6777 5.94926Z",
    fill: "#0B907B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/Tick.a33230ccb0adaf136de1470a3d036566.svg";
export { ForwardRef as ReactComponent };